import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AlertController, ModalController, NavParams, ToastController } from '@ionic/angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Zone } from './../../classes';
import { SettingsmanagerService } from './../../services/settingsmanager.service';
import { ZoneService } from 'src/app/services/zone.service';
import { HttpStatusCodesEnum } from 'src/app/utils/httpStatusCodesEnum';
import { EntityTypeEnum, ITranslation } from 'src/app/classes/ITranslation';
import { Subscription } from 'rxjs';
import { WsmanagerService } from 'src/app/services/wsmanager.service';

declare const google;

@Component({
  selector: 'app-zonedetail',
  templateUrl: './zonedetail.page.html',
  styleUrls: ['./zonedetail.page.scss']
})
export class ZonedetailPage implements OnInit {
  public isSpinnerVisible = false;

  public zone: Zone = null;
  public zoneForm: FormGroup;
  public validation_messages = null;
  public currentZoneId = null;
  public currentCityId = null;
  public cities = null;

  //supporto modale tranduzioni
  public showTranslationsModal = false;
  public translations: ITranslation[] = [];
  public subscriptions: Subscription[] = [];
  public entityType: EntityTypeEnum = EntityTypeEnum.Zone;
  public entityId = -1;

  constructor(
    private navParams: NavParams,
    private translate: TranslateService,
    private settingsManager: SettingsmanagerService,
    private formBuilder: FormBuilder,
    private _zoneSvc: ZoneService,
    private toastController: ToastController,
    public alertController: AlertController,
    private modalController: ModalController,
    private wsManager: WsmanagerService
  ) {
    console.log('@contructor-ZONE DETAIL');
  }

  ngOnInit() {
    console.log('@ngOnInitZONE DETAIL');
    // Retrieving page parameters
    const zoneString = this.navParams.get('zone');
    const zoneCoordinatesString = this.navParams.get('zone_coordinates') || '';
    this.currentZoneId = this.navParams.get('zone_id');
    this.currentCityId = this.settingsManager.getCitySetting();
    this.cities = this.settingsManager.getCitiesOptions();

    // console.log('-->zoneString:', zoneString);

    // Creating the Zone Object
    if (this.currentZoneId) {
      this.zone = new Zone(JSON.parse(zoneString));
      console.log('this.currentZoneId this.zone: ', this.zone);
    } else {
      this.zone = new Zone();
      this.zone.coordinates = zoneCoordinatesString;
      this.zone.park_enabled = true;
      this.zone.isVisible = false;
      this.zone.warning_chiusura_attivo = false;
    }

    let cityValue;
    if (this.zone.cityId) {
      cityValue = Number(this.zone.cityId) || '';
    } else {
      cityValue = Number(this.currentCityId) || '';
    }

    console.log('-->zoneObject:', this.zone, cityValue, this.zone.area);

    // Calcolo l'area della zona se non è presente
    if ((!this.zone.area || this.zone.area === 0) && this.zone.coordinates) {
      const zoneArea = this.getZoneArea(this.zone.coordinates);
      this.zone.area = zoneArea ? zoneArea : 0;
    }

    // default values
    const park_enabled_string = this.zone.park_enabled ? 'true' : 'false';
    const isVisible_string = this.zone.isVisible ? 'true' : 'false';
    const warning_string = this.zone.warning_chiusura_attivo ? 'true' : 'false';
    const command_type_string = this.zone.commandTypeId;
    const zone_area = this.zone.area ? this.zone.area : 0;

    console.log('@@@@isVisible_string:', isVisible_string);

    /* Zone Form report */
    this.entityId = +this.zone.id;
    this.loadTranslationsByEntity();
    this.zoneForm = this.formBuilder.group({
      id: [this.zone.id || null, Validators.compose([])],
      coordinates: [this.zone.coordinates || '', Validators.compose([Validators.required])],
      name: [this.zone.name || '', Validators.compose([Validators.required, Validators.maxLength(128)])],
      description: [this.zone.description || '', Validators.compose([Validators.required, Validators.maxLength(512)])],
      cityId: [cityValue, Validators.compose([Validators.required])],
      commandTypeId: [command_type_string],
      park_enabled: [park_enabled_string, Validators.compose([Validators.required])],
      isVisible: [isVisible_string, Validators.compose([Validators.required])],
      warning_chiusura_attivo: [warning_string, Validators.compose([Validators.required])],
      color: [this.zone.color || 'ABABAB', Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(6)])],
      area: [zone_area, Validators.compose([])],
      categoryFlags: [this.zone.categoryFlags || 0, Validators.compose([Validators.min(1)])],
      zIndex: [this.zone.zIndex || 0, Validators.compose([Validators.required])],
      timeslots: [this.zone.timeslots || 0, []]
    });
    this.validation_messages = {
      coordinates: [{ type: 'required', message: 'This field is required.' }],
      name: [
        { type: 'required', message: 'This field is required.' },
        {
          type: 'maxlength',
          message: 'This field must have at most 128 characters.'
        }
      ],
      description: [
        { type: 'required', message: 'This field is required.' },
        {
          type: 'maxlength',
          message: 'This field must have at most 512 characters.'
        }
      ],
      cityId: [{ type: 'required', message: 'This field is required.' }],
      commandTypeId: [{ type: 'required', message: 'This field is required.' }],
      park_enabled: [{ type: 'required', message: 'This field is required.' }],
      isVisible: [{ type: 'required', message: 'This field is required.' }],
      warning_chiusura_attivo: [{ type: 'required', message: 'This field is required.' }],
      color: [
        { type: 'required', message: 'This field is required.' },
        {
          type: 'minlength',
          message: 'This field must have just 6 characters.'
        },
        {
          type: 'maxlength',
          message: 'This field must have just 6 characters.'
        }
      ],
      validity_flag: [
        {
          type: 'required',
          message: 'subscription_registry.validity_flag_required'
        }
      ],
      categoryFlags: [{ type: 'required', message: 'This field is required.' }],
      zIndex: [{ type: 'required', message: 'This field is required.' }]
    };
  }

  private getZoneArea(coordinates) {
    let zoneArray = [];
    const areaPathArray = [];
    // Separo i vertici del poligopno
    zoneArray = coordinates.split(';');
    // console.log('@@@@zoneArray:', zoneArray);
    zoneArray.forEach((element) => {
      // Separo le coordinate dei vertici del poligono
      const arr = element.split(',');
      areaPathArray.push(new google.maps.LatLng(arr[0], arr[1]));
    });
    // console.log('@@@@areaPathArray:', areaPathArray);
    const zoneArea = google.maps.geometry.spherical.computeArea(areaPathArray).toFixed(2);
    console.log('@@@@CALCOLA AREA --> getZoneArea:', zoneArea);
    return zoneArea;
  }

  showSpinner() {
    this.isSpinnerVisible = true;
  }

  // traduzioni
  refreshContent(refreshEvent: { method: 'CREATE' | 'DELETE' | 'EDIT'; translation: ITranslation }) {
    const lang = this.settingsManager.getLanguageSetting();
    const { method, translation } = refreshEvent;
    switch (method) {
      case 'CREATE':
        this.translations.push(translation);
        this.translations = [...this.translations];
        break;
      case 'DELETE':
        this.translations = this.translations.filter((t) => t.id !== translation.id);
        break;
      case 'EDIT': {
        const index = this.translations.findIndex((t) => t.id === translation.id);
        this.translations[index] = translation;
        break;
      }
    }
    if (translation.locale === lang) {
      if (translation.value === '') {
        this.zoneForm.get(translation.field).setValue(this.zone[translation.field]);
      } else {
        this.zoneForm.get(translation.field).setValue(translation.value);
      }
    }
  }

  changeEntityLanguage(language: string) {
    this.settingsManager.setLanguageSetting(language);
    const fieldsToReset = ['name', 'description'];
    fieldsToReset.forEach((field) => {
      if (this.zoneForm.get(field)) {
        this.zoneForm.get(field).setValue(this.zone[field]);
      }
    });
    const localizedtranslations = this.translations.filter((t) => t.locale === language);
    localizedtranslations.forEach((lt) => {
      this.zoneForm.get(lt.field).setValue(lt.value);
    });
  }

  loadTranslationsByEntity() {
    this.subscriptions.push(
      this.wsManager.fetchTranslations(this.entityType, this.entityId).subscribe(
        (response) => {
          console.log('@@@@@ translations by entity');
          this.translations = response;
        },
        (err) => {
          console.error('Error fetching translations:', err);
        },
        () => {
          console.log('Completed fetching translations.');
        }
      )
    );
  }

  hideSpinner() {
    this.isSpinnerVisible = false;
  }

  async closePopover(reloadParent = false) {
    await this.modalController.dismiss(reloadParent);
  }

  async onSubmit(values) {
    console.log('@@ ZONE submit: ', values);
    console.log('@@ ZONE submit zoneForm: ', this.zoneForm);
    console.log('@@ ZONE submit zoneForm.controls: ', this.zoneForm.controls);
    this.showSpinner();
    // Ricalcolo l'area della zona perché potrebbe essere cambiata
    if (values['coordinates']) {
      const zoneArea = this.getZoneArea(values['coordinates']);
      values['area'] = zoneArea ? zoneArea : 0;
    }
    if (this.currentZoneId) {
      // EDIT
      this._zoneSvc.edit(this.currentZoneId, values).subscribe(
        (response) => {
          console.log('onSubmit OK', response);
          this.hideSpinner();
          const actiondMsg = this.translate.instant('Zone edited successfully.');
          this.showMessage('success', actiondMsg);
          this.closePopover(true);
        },
        (err) => {
          console.log('onSubmit KO', err.status, err);
          this.hideSpinner();
          let actiondMsg;
          if (err.status === 409) {
            actiondMsg = this.translate.instant('Wrong coordinates. This zone overlaps another zone.');
          } else if (err.status === HttpStatusCodesEnum.CONFLICT && err.error && err.error.overlappingTimeslot) {
            actiondMsg = this.translate.instant('overlappingTimeslot');
          } else {
            actiondMsg = this.translate.instant('Error editing the zone.');
          }
          this.showMessage('danger', actiondMsg);
        }
      );
    } else {
      this._zoneSvc.create(values).subscribe(
        () => {
          // ADD
          this.hideSpinner();
          const actiondMsg = this.translate.instant('Zone added successfully.');
          this.showMessage('success', actiondMsg);
          this.closePopover(true);
        },
        (err) => {
          this.hideSpinner();
          let actiondMsg;
          console.log(err);
          if (err.status === 409 && err.error && err.error.overlappingZone) {
            actiondMsg = this.translate.instant('Wrong coordinates. This zone overlaps another zone.');
          } else if (err.status === HttpStatusCodesEnum.CONFLICT && err.error && err.error.overlappingTimeslot) {
            actiondMsg = this.translate.instant('Overlapping timeslot');
          } else if (err.status === 403) {
            actiondMsg = this.translate.instant('The zone is outside the city.');
          } else {
            actiondMsg = this.translate.instant('Error creating the zone.');
          }
          this.showMessage('danger', actiondMsg);
        }
      );
    }
  }

  async showMessage(messageSeverity: string, messageText: string, messageDuration = 2000): Promise<void> {
    const toast = await this.toastController.create({
      message: messageText,
      translucent: true,
      color: messageSeverity,
      duration: messageDuration,
      position: 'bottom',
      mode: 'md',
      cssClass: messageSeverity
    });
    toast.present();
  }

  deleteZone() {
    this.presentAlertConfirm(this.currentZoneId);
  }

  saveTimeslots(timeslots) {
    this.zoneForm.controls['timeslots'].setValue(timeslots);
  }

  async presentAlertConfirm(zoneId: number) {
    const alert = await this.alertController.create({
      header: this.translate.instant('Are you sure to proceed?'),
      // message: 'Message <strong>text</strong>!!!',
      buttons: [
        {
          text: this.translate.instant('Cancel'),
          role: 'cancel',
          cssClass: 'secondary'
        },
        {
          text: 'Ok',
          handler: () => {
            console.log('Delete zone');
            this._zoneSvc.delete(zoneId).subscribe(
              () => {
                const msgOK = this.translate.instant('Zone removed successfully.');
                this.showMessage('success', msgOK);
                this.closePopover(true);
              },
              () => {
                const msgKO = this.translate.instant('Error removing the zone.');
                this.showMessage('danger', msgKO);
              }
            );
          }
        }
      ]
    });

    await alert.present();
  }
}
